import { yupResolver } from '@hookform/resolvers/yup';
import dayjs from 'dayjs';
import { isNil } from 'lodash';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

import type { Dayjs } from 'dayjs';
import type { Resolver } from 'react-hook-form';

/**
 * A Yup date schema that accepts Date | Dayjs | string | null as input
 * and transforms to Date | null before validation.
 * This enables .min(), .max(), etc. to work correctly regardless of input type.
 */
const coerceDayjsDate = () =>
  Yup.date().transform((value, originalValue) => {
    if (isNil(originalValue) || originalValue === '') {
      return null;
    }

    const dayjsValue = dayjs(originalValue);
    if (dayjsValue.isValid()) {
      return dayjsValue.toDate();
    }

    return value;
  });

export const attendanceEditSchema = Yup.object({
  startOperationTime: coerceDayjsDate().nullable(),
  endOperationTime: coerceDayjsDate().nullable(),
  breakDurationMinute: Yup.number().min(0).nullable(),
});

export type AttendanceEditFormValues = {
  startOperationTime?: Date | Dayjs | string | null;
  endOperationTime?: Date | Dayjs | string | null;
  breakDurationMinute?: number | null;
};

export type AttendanceEditFormTransformedValues = Yup.InferType<typeof attendanceEditSchema>;

export type UseAttendanceEditFormProps = Parameters<
  typeof useForm<AttendanceEditFormValues, unknown, AttendanceEditFormTransformedValues>
>[0];

const useAttendanceEditForm = (props?: UseAttendanceEditFormProps) => {
  const form = useForm<AttendanceEditFormValues, unknown, AttendanceEditFormTransformedValues>({
    resolver: yupResolver(attendanceEditSchema) as unknown as Resolver<AttendanceEditFormValues>,
    ...props,
  });

  return form;
};

export default useAttendanceEditForm;
